export const AUTO = "auto"
export const TRIAL = "trial"
export const VOGWEEK = "vogweek"
export const VOILES_ET_VOILIERS = "voiles_et_voiliers"
